import { IGoogleReservationsSettings } from '@backend/domain'
export class GoogleReservationsSettings implements IGoogleReservationsSettings {
	enabled: boolean
}
